import { http } from "../../config/Constantes";
import lscache from "lscache";

export default class BaseService {

    tamanhoPagina = 10000;

    httpGet(url, isBlob = false) {
        lscache.flushExpired()
        const headers = (lscache.get('access_token')) ? { Authorization: lscache.get('access_token') } : {}
        var requestConfig = { headers }
        if (isBlob) {
            requestConfig.responseType = 'blob'
        }  
        return http.get(url, requestConfig)
            .then(function (response) {
                return response;
            }).catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                        lscache.flush();
                        lscache.set("errorMessage", "Senha expirada, acesse a opção 'esqueci minha senha'.")                       
                        window.location.replace("/login")
                    }
                    return error.response;
                } else return "Verifique sua conexão";
            });
    }

    httpPost(url, item, needToken = true) {
        lscache.flushExpired()
        if (lscache.get('access_token')) {
            return http.post(url, item, {
                headers: { Authorization: lscache.get('access_token') }
            }).then(function (response) {
                return response;
            }).catch(error => {
                if (error.response) {
                    if (error.response.status === 401) {
                        lscache.flush();
                        lscache.set("errorMessage", "Senha expirada, acesse a opção 'esqueci minha senha'.")                       
                        //window.location.replace("/login")
                    }
                    return error.response;
                } else return "Verifique sua conexão";
            });
        } else if (!needToken) {
            return http.post(url, item)
                .then(response => response)
                .catch(error => {
                    if (error.response) {
                        if (error.response.status === 401) {
                            lscache.flush();
                            lscache.set("errorMessage", "Senha expirada, acesse a opção 'esqueci minha senha'.")                         
                            //window.location.replace("/login")
                        }
                        return error.response;
                    } else return "Verifique sua conexão";
                });
        } else {
            //window.location.replace("/login")
            //this.loginStore = new LoginStore();
            //return this.loginStore.login();
        }
    }

    async httpPut(url, item) {
        lscache.flushExpired();
        if (lscache.get('access_token')) {
            try {
                const response = await http.put(url, item, {
                    headers: { 'Content-Type': 'application/json', Authorization: lscache.get('access_token') }
                });
                return response;
            }
            catch (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        lscache.flush();
                        lscache.set("errorMessage", "Senha expirada, acesse a opção 'esqueci minha senha'.");                       
                    }
                    return error.response;
                }
                else
                    return "Verifique sua conexão";
            }
        }
    }

    async httpDelete(url) {
        lscache.flushExpired();
        if (lscache.get('access_token')) {
            try {
                const response = await http.delete(url, {
                    headers: { 'Content-Type': 'application/json', Authorization: lscache.get('access_token') }
                });
                return response;
            }
            catch (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        lscache.flush();
                        lscache.set("errorMessage", "Senha expirada, acesse a opção 'esqueci minha senha'.");                        
                    }
                    return error.response;
                }
                else
                    return "Verifique sua conexão";
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/services/geral/BaseService.js